module.exports = __webpack_public_path__ + "static/media/hiw3blue.b111bf43.svg";